import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/styles.scss';export default {
  "documentsPage": "_documentsPage_1v0kx_1",
  "header": "_header_1v0kx_9",
  "content": "_content_1v0kx_16",
  "main": "_main_1v0kx_24",
  "dropPreview": "_dropPreview_1v0kx_33",
  "dragContent": "_dragContent_1v0kx_41",
  "documents": "_documents_1v0kx_1",
  "list": "_list_1v0kx_54",
  "docViewer": "_docViewer_1v0kx_64",
  "loader": "_loader_1v0kx_72",
  "draggedItem": "_draggedItem_1v0kx_92",
  "dropZone": "_dropZone_1v0kx_97"
};